module.exports = __webpack_public_path__ + "img/img10.ae6df72d.jpg";